<template>
	<v-menu offset-y eager>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon small v-bind="attrs" v-on="on" color="primary">
				<v-icon>mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list dense>
			<v-list-item v-if="item.action && item.action.type" link @click="$emit('open', { item })">
				<v-list-item-title class="size9 font-weight-medium">{{ item.action.label || 'Apri' }}</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.action && item.action.type === 'discount'" link @click="$emit('open', { item, tipo: 'simulate' })">
				<v-list-item-title class="size9">Simula prima</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.type === 'viewed' && item.data.coupon" link @click="$emit('open', { item, tipo: 'coupon' })">
				<v-list-item-title class="size9">Crea coupon del {{ item.data.coupon }}%</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.data && item.data.item && item.action && item.action.type !== 'openItem' && item.action.type !== 'rewrite'" link @click="$emit('open', { item, tipo: 'item' })">
				<v-list-item-title class="size9">Apri prodotto</v-list-item-title>
			</v-list-item>
			<v-divider></v-divider>
			<template v-if="aperto">
				<v-list-item link @click="$emit('status', { item, status: 'done' })">
					<v-list-item-title class="size9">Segna come fatto</v-list-item-title>
				</v-list-item>
				<v-list-item link @click="$emit('status', { item, status: 'snoozed', snoozeDays: 7 })">
					<v-list-item-title class="size9">Rimanda di 7 giorni</v-list-item-title>
				</v-list-item>
				<v-list-item link @click="$emit('status', { item, status: 'dismissed' })">
					<v-list-item-title class="size9">Ignora</v-list-item-title>
				</v-list-item>
			</template>
			<v-list-item v-else link @click="$emit('status', { item, status: 'new' })">
				<v-list-item-title class="size9">Rimetti fra i consigli da fare</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
// menu a tre puntini di un consiglio: l'azione suggerita in cima, poi lo stato.
// Le pagine di destinazione le apre la lista, che si fa riportare indietro (openWithReturn)
export default {
	name: 'InsightRowMenu',
	props: {
		item: { type: Object, required: true },
	},
	computed: {
		aperto() {
			return this.item.status === 'new' || (this.item.status === 'snoozed' && new Date(this.item.snoozeUntil) <= new Date());
		},
	},
};
</script>
